// extracted by mini-css-extract-plugin
export var closeButton = "_34-3";
export var header = "_34-0";
export var link = "_34-1";
export var retryButton = "_34-2";